import { useEffect, useState } from 'react';

interface UseCarouselComponent {
  slides: any[];
  isHovered: boolean;
  autoPlay: boolean;
}

/**
 * This custom hook is used to handle the navigation of the carousel
 * @param slides - slides
 */
const useCarouselElement = ({ slides, isHovered, autoPlay }: UseCarouselComponent) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // this function is used to navigate to the previous slide
  const prevSlide = () => {
    setCurrentIndex(currentIndex === 0 ? slides?.length - 1 : currentIndex - 1);
  };

  // this function is used to navigate to the next slide
  const nextSlide = () => {
    setCurrentIndex(currentIndex === slides?.length - 1 ? 0 : currentIndex + 1);
  };

  // this function is used to navigate to the selected slide
  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
  };

  // this function is used to set the current index with a given timeout value
  useEffect(() => {
    if (!autoPlay) return;
    if (isHovered) return;
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, slides, isHovered, autoPlay]);

  // this function is used to reset the current index if the slides array's length changes
  useEffect(() => {
    setCurrentIndex(0);
  }, [slides.length]);

  return {
    currentIndex,
    prevSlide,
    nextSlide,
    handleDotClick,
    setCurrentIndex,
  };
};

export default useCarouselElement;
